const CameltoPascalCase = (camelCaseString: string) => {
    return camelCaseString[0].toUpperCase() + camelCaseString.substring(1, camelCaseString.length);
}

export default CameltoPascalCase;